import styled from "styled-components";

export const Wrapper = styled.div`
    *{
        color: #828282;
        font-weight:500;
        text-align:center;
    }
    a{
        font-weight:700;
    }
    @media (max-width: 376px){
        font-size: .9rem;
    }
`